import * as moment from 'moment';
import { DateFormat, DateFormatHelper } from './helpers';

const helper = new DateFormatHelper();

export function getAxisFormat(duration: moment.Duration, width: number, domain: Date[], isYAxisVisible: boolean): { format: DateFormat, ticks: Date[] } {
    const format = helper.format(duration);
    const formatLength = format.length;
    const ticks = helper.getTicks(domain as [Date, Date], width, duration, formatLength);
    return {
        format,
        ticks
    };
}